export default {
  GET    : 'GET',
  POST   : 'POST',
  PUT    : 'PUT',
  DELETE : 'DELETE',
  PATCH  : 'PATCH'
};
